module.exports = __webpack_public_path__ + "static/media/mrmeeseeks.51da63bb.png";